module.exports = __webpack_public_path__ + "static/img/login-demo.14e7872.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loginGuide/login-demo.png
// module id = 168
// module chunks = 0